import { useTranslation } from 'react-i18next'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../../utils/api'
import { ContentType } from '../../utils/api/tools'
import { GET_RELATIVE_SCG, useGetEClaimById, CREATE_USER_CLAIM } from '../e-claim/e-claim-query'
import { CreateEclaimUserResponse, RelativeScgResponse } from '../e-claim/e-claim-types'
import { GET_USER_COIN_URL } from '../user/user-query'
import { EClaimsHistoryListResponse, EClaimListResponse } from '../e-claim/e-claim-types'
import { E_CLAIM_LIST, E_CLAIM_BY_ID } from '../e-claim/e-claim-query'
import { CreateHepatitisUser } from './hepatitis-types'

const APP = '/app'
export const USER_CLAIM = 'userClaim'
export const HEPATITIS_HISTORY_LIST = `${APP}/${USER_CLAIM}/getAllUserClaimByUser`

export const useGetHepatitisById = useGetEClaimById

export const useGetHepatitisList = (groupName = 'hepatitis') => {
  return useQuery<EClaimListResponse>([E_CLAIM_LIST, groupName], () => {
    return api.belive.get<EClaimListResponse>(`${E_CLAIM_LIST}?claimTypeGroupName=${groupName}`)
  })
}

export const useCreateHepatitisClaim = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (data: CreateHepatitisUser) => {
      const {
        claimId,
        receiptAmount,
        receiptDate,
        relativeId,
        consentDate,
        consentBy,
        userClaimDocumentList,
        receiptNo,
      } = data
      return api.belive.post<CreateEclaimUserResponse>(
        CREATE_USER_CLAIM,
        JSON.stringify({
          claimId,
          receiptAmount,
          receiptDate,
          relativeId,
          consentDate,
          consentBy,
          userClaimDocumentList,
          receiptNo,
        }),
        { contentType: ContentType.JSON },
      )
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([E_CLAIM_LIST])
        queryClient.invalidateQueries([E_CLAIM_BY_ID])
        queryClient.invalidateQueries([HEPATITIS_HISTORY_LIST])
        queryClient.invalidateQueries([GET_USER_COIN_URL])
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}

export const useGetHepatitisHistoryList = (groupCode = 'hepatitis') => {
  return useQuery([HEPATITIS_HISTORY_LIST, groupCode], () => {
    return api.belive.get<EClaimsHistoryListResponse>(`${HEPATITIS_HISTORY_LIST}?claimTypeGroupCode=${groupCode}`)
  })
}

export const useGetRelativeOption = (claimId?: number) => {
  return useQuery([GET_RELATIVE_SCG, 'options', claimId], async () => {
    const data = await api.belive.get<RelativeScgResponse>(`${GET_RELATIVE_SCG}/opd/${claimId}`)
    const optionRelative: {
      label: string
      value: Record<string, string>
      disabled?: boolean
    }[] = []

    data.map((relative) => {
      const { firstname, lastname, id, typeId, typeName } = relative
      optionRelative.push({
        label: `${typeName}: ${firstname} ${lastname}`, value: {
          id: id.toString(),
          typeId: typeId.toString(),
        }
      })
    })
    // }

    return optionRelative
  })
}